import { render, staticRenderFns } from "./MaterialSpace.vue?vue&type=template&id=334d67f0"
import script from "./MaterialSpace.vue?vue&type=script&lang=js"
export * from "./MaterialSpace.vue?vue&type=script&lang=js"
import style0 from "./MaterialSpace.vue?vue&type=style&index=0&id=334d67f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports